var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68761 6.98121L4.79561 4.13304C4.61561 3.95576 4.32761 3.95576 4.14761 4.13304C3.96761 4.31031 3.96761 4.59394 4.14761 4.77121L7.03961 7.6194H5.46761C5.21561 7.6194 5.01161 7.82031 5.01161 8.06849C5.01161 8.31667 5.21561 8.51758 5.46761 8.51758H8.14361C8.39561 8.51758 8.59961 8.31667 8.59961 8.06849V5.44485C8.59961 5.23212 8.45561 5.03121 8.22761 4.98394C7.93961 4.92485 7.67561 5.14939 7.67561 5.42121L7.68761 6.98121Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45562 11.6199H7.02761L4.13562 14.4681C3.95562 14.6454 3.95562 14.929 4.13562 15.1063C4.31562 15.2836 4.60361 15.2836 4.78361 15.1063L7.67562 12.2581V13.8063C7.67562 14.0899 7.92761 14.3027 8.22761 14.2436C8.44361 14.2081 8.59961 14.0072 8.59961 13.7827V11.159C8.59961 10.9108 8.39561 10.7099 8.14361 10.7099H5.47961C5.26361 10.7099 5.05961 10.8518 5.01161 11.0763C4.95161 11.3718 5.16762 11.6199 5.45562 11.6199Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9571 7.6194H12.3851L15.2771 4.77121C15.4571 4.59394 15.4571 4.31031 15.2771 4.13304C15.0971 3.95576 14.8091 3.95576 14.6291 4.13304L11.7371 6.98121V5.43304C11.7371 5.18485 11.5331 4.98394 11.2811 4.98394C11.0291 4.98394 10.8251 5.18485 10.8251 5.43304V8.06849C10.8251 8.31667 11.0291 8.51758 11.2811 8.51758H13.9451C14.1611 8.51758 14.3651 8.37576 14.4131 8.15122C14.4611 7.86758 14.2451 7.6194 13.9571 7.6194Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8251 11.1591V13.7946C10.8251 14.0428 11.0291 14.2437 11.2811 14.2437C11.5331 14.2437 11.7371 14.0428 11.7371 13.7946V12.2464L14.6291 15.0946C14.8091 15.2719 15.0971 15.2719 15.2771 15.0946C15.4571 14.9173 15.4571 14.6337 15.2771 14.4564L12.3851 11.6082H13.9571C14.2091 11.6082 14.4131 11.4073 14.4131 11.1591C14.4131 10.911 14.2091 10.71 13.9571 10.71H11.2811C11.0291 10.71 10.8251 10.911 10.8251 11.1591Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseImg);
export default __webpack_public_path__ + "static/media/collapseImg.f0c6cde6a5c328e8cbf6574e47dd4398.svg";
export { ForwardRef as ReactComponent };